import { Injectable } from '@angular/core';

import { SwUpdate } from '@angular/service-worker';
import { CustomSnackbarConfig, SCConfig } from './../../sc-config/constant/sc-config.constant';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../shared/services/common.service';

@Injectable()
export class UpdateService {
    constructor(
        private swUpdate: SwUpdate,
        private translateService: TranslateService,
        private commonService: CommonService
    ) {
        if (!this.swUpdate.isEnabled) {
        } else {
            swUpdate.checkForUpdate().then(() => {});
        }
    }

    public checkForUpdates(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.checkForUpdate();
        }
    }

    public subscribeForAutomaticVersionUpdate(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates.subscribe(() => {
                this.showUpdateToastMessage();
                this.swUpdate.activateUpdate().then(() => location.reload());
            });
        }
    }

    showUpdateToastMessage() {
        let config = new CustomSnackbarConfig();
        config.Type = SCConfig.SnackbarType.SUCCESS;
        config.Message = this.translateService.instant('UPDATE_AVAILABLE');
        this.commonService.showCustomSnackbarMessage(config);
    }
}
